<script>
    import Input from "../leafElement/Input.svelte";
    import Label from "../leafElement/Label.svelte";
    import { getDataLoader } from "../script/dataLoader";
    import { UserCredential } from "../script/store";
    import { USER_ROLE } from "../script/common";
    import { onDestroy } from "svelte";
    import { loginUser } from "../script/commonRequests";

    let formInvalid = true;
    let formVal = {
        name: "",
        password: "",
    };
    let userData;
    let showWrongUserDataWarning = false;

    $: {
        formInvalid = !formVal.name || !formVal.password;
    }

    /* function generateStateUpdateHandleFor(valName) {
        return (data) => {
            formData[valName] = data;
            if (data.valid) {
            } else {
            }
        };
    } */
    const userCredentialDestructor = UserCredential.subscribe((userInfo) => {
        userData = userInfo;
        // DEV
        /* userData = { 
            userName: "nykl",
            role: 0,
            roleDisplayed: "Technik",
        }; */
    });
    async function submit() {
        const res = await loginUser(formVal.name, formVal.password);
        if (!res) {
            showWrongUserDataWarning = true;
            setTimeout(() => {
                showWrongUserDataWarning = false;
            }, 2000); // to do destructor
        }
    }
    function removeCredentials() {
        UserCredential.disconect();
    }

    onDestroy(userCredentialDestructor);
</script>

<div>
    {#if !userData}
        <div class="logInTitle">
            <span class="material-icons"> assignment_ind </span>
            <span>Přihlášení</span>
        </div>
        <div class="simpleForm" style="margin-top: .5rem;">
            <Input bind:val={formVal.name} name={"Jméno"} required={true} />
            <div style="margin-top: .5rem;">
                <Input
                    bind:val={formVal.password}
                    name={"Pin"}
                    inputType={"password"}
                    required={true}
                />
            </div>
            <!-- <input type="submit" value="Submit"> -->
            <div class="shiftSpace">
                {#if showWrongUserDataWarning}
                    <div class="standartdMesageCentered">
                        <div class="standartFilledMesage warningColors">
                            <span class="material-icons"> warning_amber </span>
                            <span>Špatné údaje</span>
                        </div>
                    </div>
                {/if}
                <button
                    class="standartButton"
                    on:click={submit}
                    disabled={formInvalid}>Přihlásit</button
                >
            </div>
        </div>
    {:else}
        <!-- <div class="loginWraper" style="margin-top: 1.5rem;">
            <span class="loginMsg">Přihlášen jako:</span>
            <span class="loginName">{userData.userName}</span>
        </div>
        <div class="loginWraper">
            <span class="loginMsg">Role:</span>
            <span class="loginName">{userData.roleInfo.displayedName}</span>
        </div> -->
        <div style="margin: 1.5rem;">
            <Label name={"Přihlášen jako:"} val={userData.userName} />
            <Label name={"Role:"} val={userData.roleInfo.displayedName} />
        </div>

        <button class="standartButton" on:click={removeCredentials}
            >Odhlásit</button
        >
    {/if}
</div>

<style>
    .logInTitle {
        display: flex;
        align-items: center;
        color: var(--back_D2);
        font-size: 1.5rem;
        font-weight: 300;
    }
    .logInTitle > .material-icons {
        font-size: 1.5em;
        margin-right: 10px;
    }
    .simpleForm {
        display: flex;
        flex-direction: column;
        align-items: stretch;
    }
    .loginWraper {
        margin: 0.8rem;
        padding: 0.5rem 0.7rem;
        background-color: var(--back_D1);
    }
    .loginMsg {
        font-weight: 300;
        font-size: 1.2rem;
    }
    .loginName {
        margin-left: 0.5em;
        font-size: 1.3rem;
        font-weight: 500;
        color: var(--back_D2);
    }
    .shiftSpace {
        display: flex;
        justify-content: flex-end;
    }
</style>
